<script lang="ts">
import {Component, toNative} from 'vue-facing-decorator'
import DomainInput from "@/components/design/domain/DomainInput.vue";
import WorkspaceRouteComponent from "@/components/shared/WorkspaceRouteComponent";
import Domain, {emptyDomain} from "@/types/Domain";
import {domainCreate} from "@/utils/heading";

@Component({components: {'ontos-domain-input': DomainInput}})
class CreateDomain extends WorkspaceRouteComponent {
  get heading() {
    return domainCreate(this.workspace)
  }

  //A mesma semente do modal de criar: ela mora no types/Domain
  domain: Domain = emptyDomain()
  declare $refs: {input: InstanceType<typeof DomainInput>}

  async save() {
    try {
      if (this.$refs.input.validateModel()) {
        await this.createDomain(this.domain)
        this.info(this.$tt('info.domain-created', {name: this.domain.name}))
        await this.$router.push({name: 'view-domain', params: {...this.$route.params, domain: this.domain.alias}})
      }
    } catch (err) {
      this.throwError(this.$tt('error.create-domain', {name: this.domain.name}), err)
    }
  }
}

export default toNative(CreateDomain)
</script>
<template>
  <ontos-base v-bind="baseProps" ref="base">
    <v-form>
      <ontos-page-header v-bind="heading"/>
      <v-row>
        <v-col cols="12">
          <ontos-domain-input ref="input" :value="domain" @input="domain = $event" :domains="workspace.domains"
                              start-with-auto-alias/>
        </v-col>
        <v-col cols="12" class="text-right">
          <v-btn size="small" color="primary" @click="save()">
            <v-icon start>mdi-content-save</v-icon>
            {{ $tt('save') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </ontos-base>
</template>
